import { BizzeySetting } from "../../../../packs/widget_shim";
import { PublicLocale, Widget } from "../../../types";
import Breakpoints, { MOBILE_BREAKPOINT } from "../../styles/breakpoints";
import {
  ApplicationState,
  ApplicationActionTypes,
  SET_APPLICATION_STATE,
  ADD_SHOW_LAUNCHER_CALLBACK,
  ADD_HIDE_LAUNCHER_CALLBACK,
  ADD_OPEN_CALLBACK,
  ADD_CLOSE_CALLBACK,
  SET_MESSENGER_FRAME,
  MAXIMIZE_WINDOW,
  MINIMIZE_WINDOW,
  TOGGLE_WINDOW_SIZE,
  SET_HOST_WINDOW_SIZE,
  SET_WINDOW_MAXIMIZED,
  SET_BIZZEY_SETTING,
  SET_WIDGET,
  SET_LOCALE,
  SET_WIDGET_SESSION,
  SET_WIDGET_COUNTERS,
  ADD_READY_CALLBACK,
} from "./types";

const initialState: ApplicationState = {
  launcherVisible: true,
  open: false,
  maximized: false,
  messengerFrame: null,
  onShowLauncherCallbacks: [],
  onHideLauncherCallbacks: [],
  onReadyCallbacks: [],
  onOpenCallbacks: [],
  onCloseCallbacks: [],
  widget: null,
  session: null,
  hostWidth: null,
  hostHeight: null,
  hostMobile: false,
  bizzeySetting: null,
  locale: PublicLocale.EN,
  counters: null,
};

export const isLauncherVisibleOnInitOrClose = (
  setting: BizzeySetting,
  widget: Widget
) => {
  if (setting?.hide_default_launcher === true) return false;
  if (setting?.hide_default_launcher === false) return true;

  return Boolean(widget?.show_launcher);
};

export default (
  state = initialState,
  action: ApplicationActionTypes
): ApplicationState => {
  switch (action.type) {
    case SET_APPLICATION_STATE:
      return {
        ...state,
        ...action.state,
      };
    case SET_BIZZEY_SETTING:
      return {
        ...state,
        bizzeySetting: action.bizzeySetting,
        launcherVisible: isLauncherVisibleOnInitOrClose(
          action.bizzeySetting,
          state.widget
        ),
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.locale as PublicLocale,
      };
    case SET_WIDGET:
      return {
        ...state,
        widget: action.widget,
        launcherVisible: isLauncherVisibleOnInitOrClose(
          state.bizzeySetting,
          action.widget
        ),
      };
    case SET_WIDGET_SESSION:
      return {
        ...state,
        session: action.session,
      };
    case SET_MESSENGER_FRAME:
      return {
        ...state,
        messengerFrame: action.messengerFrame,
      };
    case ADD_SHOW_LAUNCHER_CALLBACK:
      return {
        ...state,
        onShowLauncherCallbacks: [
          ...state.onShowLauncherCallbacks,
          action.callback,
        ],
      };
    case ADD_HIDE_LAUNCHER_CALLBACK:
      return {
        ...state,
        onHideLauncherCallbacks: [
          ...state.onHideLauncherCallbacks,
          action.callback,
        ],
      };
    case ADD_READY_CALLBACK:
      return {
        ...state,
        onReadyCallbacks: [...state.onReadyCallbacks, action.callback],
      };
    case ADD_OPEN_CALLBACK:
      return {
        ...state,
        onOpenCallbacks: [...state.onOpenCallbacks, action.callback],
      };
    case ADD_CLOSE_CALLBACK:
      return {
        ...state,
        onCloseCallbacks: [...state.onCloseCallbacks, action.callback],
      };
    case MAXIMIZE_WINDOW:
      return {
        ...state,
        maximized: true,
      };
    case MINIMIZE_WINDOW:
      return {
        ...state,
        maximized: false,
      };
    case TOGGLE_WINDOW_SIZE:
      return {
        ...state,
        maximized: !state.maximized,
      };
    case SET_HOST_WINDOW_SIZE:
      return {
        ...state,
        hostWidth: action.width,
        hostHeight: action.height,
        hostMobile: action.width <= MOBILE_BREAKPOINT,
      };
    case SET_WINDOW_MAXIMIZED:
      return {
        ...state,
        maximized: action.maximized,
      };
    case SET_WIDGET_COUNTERS:
      return {
        ...state,
        counters: action.counters,
      };
    default:
      return state;
  }
};
